// Simple local mock. Replace with your real API later.
export async function loginUser(username, password) {
  const DEMO_EMAIL = 'emily@mywrapmarket.com';
  const DEMO_PASS  = 'V7h$9mN2!wr@PM';

  await new Promise(r => setTimeout(r, 300)); // simulate latency

  if (username === DEMO_EMAIL && password === DEMO_PASS) {
    return {
      data: {
        token: 'demo.jwt.token.here',
        id: 'u_demo_emily',
        username: DEMO_EMAIL,
        role: 1
      }
    };
  }

  const err = new Error('Invalid email or password');
  err.status = 401;
  throw err;
}

export default { loginUser };
